var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "view-all-component" } },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$i18n.t("tender.viewAll.title")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-btns" },
            [
              _vm.showCreateButton
                ? _c("ConfirmCreate", { staticClass: "create-btn" })
                : _vm._e(),
              _vm._v(" "),
              _vm.canExtendClosingDate
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: {
                        type: "button",
                        disabled: !(
                          _vm.closingDateSearch && _vm.extendTenders.length
                        ),
                      },
                      on: { click: _vm.extendClosingDate },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.extendClosingDate")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canExportSearchResults
                ? _c(
                    "HKLButton",
                    {
                      attrs: { color: "orange" },
                      on: { click: _vm.exportTenders },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.exportSearchResults")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: { click: _vm.resetFilters },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.resetFilter")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "query-btn", type: "button" },
                  on: { click: _vm.queryTenders },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.search")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isHKlandUser
        ? _c(
            "AdvanceSearchCollapse",
            {
              staticClass: "advance-search-group",
              attrs: { id: "tender-advance-search-condition-group" },
            },
            [
              _c(
                "div",
                { staticClass: "invited-vendor" },
                [
                  _c(
                    "label",
                    { staticClass: "emphasis ad-search-condition-label" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("projectViewAll.invitedVendor")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLInput", {
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.queryTenders.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.invitedVendorName,
                      callback: function ($$v) {
                        _vm.invitedVendorName = $$v
                      },
                      expression: "invitedVendorName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "issue-date-range" },
                [
                  _c(
                    "label",
                    { staticClass: "emphasis ad-search-condition-label" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tender.issuedDate")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLDateRange", {
                    attrs: {
                      canPutTotop: false,
                      placeholders: [
                        _vm.$t("projectViewAll.startFrom"),
                        _vm.$t("projectViewAll.until"),
                      ],
                    },
                    model: {
                      value: _vm.advancedDateRange.issuedDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.advancedDateRange, "issuedDate", $$v)
                      },
                      expression: "advancedDateRange.issuedDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "closing-date-range" },
                [
                  _c(
                    "label",
                    { staticClass: "emphasis ad-search-condition-label" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tender.closingDate")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLDateRange", {
                    attrs: {
                      displayRange: [{ to: null }, { to: null }],
                      canPutTotop: false,
                      placeholders: [
                        _vm.$t("projectViewAll.startFrom"),
                        _vm.$t("projectViewAll.until"),
                      ],
                    },
                    model: {
                      value: _vm.advancedDateRange.closingDateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.advancedDateRange, "closingDateRange", $$v)
                      },
                      expression: "advancedDateRange.closingDateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "awarded-date-range" },
                [
                  _c(
                    "label",
                    { staticClass: "emphasis ad-search-condition-label" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tender.awardedDate")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLDateRange", {
                    attrs: {
                      canPutTotop: false,
                      placeholders: [
                        _vm.$t("projectViewAll.startFrom"),
                        _vm.$t("projectViewAll.until"),
                      ],
                    },
                    model: {
                      value: _vm.advancedDateRange.awardedDateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.advancedDateRange, "awardedDateRange", $$v)
                      },
                      expression: "advancedDateRange.awardedDateRange",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view-all-component-tenders" },
        [
          _c("div", [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("total")) + ": " + _vm._s(_vm.displayTotalCount)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "view-all-component-tenders",
            attrs: {
              defaultOrderKey: _vm.defaultOrderKey,
              orderByDateKeys: ["awardedDate", "closingDate"],
              orderByNumberKeys: ["awardedAmount", "prNumber"],
              renderHeaderList: _vm.itemHeaders,
              tableId: _vm.tableId,
              needSearch: true,
              needCache: _vm.shouldUseTableCache,
              yScrollAuto: true,
              tableContentLists: _vm.parsedItems,
              getDisplayListLength: _vm.getDisplayListLength,
              defaultOrder: true,
              interactionFunc: _vm.interactionFunc,
              getConditions: _vm.getConditionsCallBack,
              enterEvent: _vm.queryTenders,
              disabledAllSearchFilter: _vm.isVendorHistory,
              setTableInfo: _vm.setTableInfo,
              getTableOrder: _vm.getTableOrder,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "extendClosingDateModal",
          staticClass: "reveal",
          attrs: { id: "extendClosingDateModal", "data-reveal": "" },
        },
        [
          _c(
            "button",
            {
              staticClass: "close-button",
              attrs: { "aria-label": "Close modal", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.closeAlertModal()
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tender-confirm clearfix modal-container" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("action.extendTo")))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row",
                  attrs: { id: "edit-closing-date-picker" },
                },
                [
                  _c("DatePicker", {
                    staticClass: "medium-5 small-5 large-5 columns",
                    class: _vm.invalidClosingDateClass,
                    attrs: {
                      format: "DD MMM YY",
                      disabled: _vm.disabledDates,
                      calendarButton: true,
                      calendarButtonIcon: "fa fa-calendar",
                    },
                    on: {
                      selected: function (val) {
                        return _vm.updateClosingDate(
                          val,
                          _vm.selectedClosingTime
                        )
                      },
                    },
                    model: {
                      value: _vm.selectedClosingDate,
                      callback: function ($$v) {
                        _vm.selectedClosingDate = $$v
                      },
                      expression: "selectedClosingDate",
                    },
                  }),
                  _vm._v(" "),
                  _c("HKLSelect", {
                    staticClass: "medium-5 small-5 large-5 columns",
                    class: _vm.invalidClosingTimeClass,
                    attrs: {
                      value: _vm.selectedClosingTime || undefined,
                      options: _vm.closingTimeHklOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        return _vm.updateClosingDate(
                          _vm.selectedClosingDate,
                          val || ""
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extendClosingDateReason,
                    expression: "extendClosingDateReason",
                  },
                  { name: "autosize", rawName: "v-autosize" },
                ],
                staticClass: "reason-box",
                class: {
                  "error-highlight":
                    _vm.tryToConfirm && !_vm.extendClosingDateReason,
                },
                attrs: {
                  type: "text",
                  placeholder:
                    "Please input the reason for extending closing date.",
                  required: "",
                },
                domProps: { value: _vm.extendClosingDateReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.extendClosingDateReason = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.itemHeaders[0].name))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.itemHeaders[1].name))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.itemHeaders[2].name))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.itemHeaders[3].name))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.itemHeaders[4].name))]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.extendTenders, function (item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(item.general.prNumber))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.general.prDescription))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.general.site))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.parseStatusText(item.general))),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            item.general.closingDate &&
                              _vm.dateUtil.formatDate(
                                item.general.closingDate,
                                true
                              )
                          )
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-right nav_btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeAlertModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.confirmExtend()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("action.ok")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "HKLRemindModal",
        { ref: "remindEmptyModal" },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("hint.emptySearch")) + "\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }